import React from 'react'
import { useDispatch } from 'react-redux'
import SVG from 'react-inlinesvg'
import cx from 'clsx'
// Redux
import { setModal } from '~lib/saga/filter/actions'
// Components
import { SortIcon } from '~2022/components/Icons'
// Styles
import useStyles from './CategoryButton.style'

const CategoryButton = () => {
  const classes = useStyles()

  const dispatch = useDispatch()
  const handleModal = (value) => dispatch(setModal(value))

  return (
    <button
      aria-controls="sort-filter-modal"
      className={cx(classes.categoryBtn)}
      onClick={() => handleModal(true)}
      tabIndex={null}
    >
      <SVG
        src={SortIcon}
        width={10}
        height={10}
        title={`Categories`}
        description="3 bars that get shorter in length"
      />
      <span className={cx(classes.categoryBtnText)}>Categories</span>
    </button>
  )
}

export default CategoryButton
